import React from 'react';
import Image from 'next/image';
import { AppContext } from '@context/AppContext';
import bannerBase from '@imgs/banner/banner-base.png';
import img03Focus from '@imgs/banner/03_1.gif';
import img06Focus from '@imgs/banner/06_1.gif';
import img09Focus from '@imgs/banner/09_1.gif';
import img10Focus from '@imgs/banner/10_1.gif';
import img13Focus from '@imgs/banner/13_1.gif';

const focusOverlays = [
	{ src: img03Focus, left: 110 / 515 * 100, top: 25 / 212 * 100, width: 77, widthPct: 77 / 515 * 100, height: 72 },
	{ src: img06Focus, left: 41 / 515 * 100, top: 97 / 212 * 100, width: 69, widthPct: 69 / 515 * 100, height: 109 },
	{ src: img09Focus, left: 264 / 515 * 100, top: 127 / 212 * 100, width: 112, widthPct: 112 / 515 * 100, height: 82 },
	{ src: img10Focus, left: 376 / 515 * 100, top: 127 / 212 * 100, width: 37, widthPct: 37 / 515 * 100, height: 28 },
	{ src: img13Focus, left: 215 / 515 * 100, top: 146 / 212 * 100, width: 32, widthPct: 32 / 515 * 100, height: 18 },
];

class BannerMain extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { context_data } = this.context;
		// Overlays show on: banner hover (pure CSS group-hover — no context
		// round trip), edit mode (message textarea visible), or input focus
		// (the touch-device trigger; is_focused stays untouched elsewhere —
		// SearchInput/TextInput use it for focus management).
		const is_focused = context_data.is_focused === "SearchInput" || context_data.is_focused === "TextInput";
		const is_active = context_data.is_textarea || is_focused;
		const overlay_class = is_active
			? "absolute transition-opacity duration-300 opacity-100"
			: "absolute transition-opacity duration-300 opacity-0 group-hover:opacity-100";

		return (
			<div className="mt-[12px] clear-both inline-block w-full max-w-[515px] p-0 text-center">
				<div className="group relative aspect-[515/212] w-full overflow-hidden">
					<Image src={bannerBase} alt="" priority fill sizes="(max-width: 515px) 100vw, 515px" />
					{focusOverlays.map((overlay) => (
						<Image
							key={`${overlay.left}-${overlay.top}`}
							src={overlay.src}
							alt=""
							width={overlay.width}
							height={overlay.height}
							className={overlay_class}
							style={{ left: `${overlay.left}%`, top: `${overlay.top}%`, width: `${overlay.widthPct}%`, height: 'auto' }}
						/>
					))}
				</div>
			</div>
		);
	}
}
BannerMain.contextType = AppContext;
export default BannerMain;
